import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInfo } from '../api/setting/users';
import { setUserInfo } from '../redux/actions';
import { RootState } from '../redux/reducers';

export const useMe = () => {
    const dispatch = useDispatch();
    const userInfo = useSelector((state: RootState) => state.userInfo);
    const [userId, setUserId] = React.useState<string | undefined>('');
    // Track the email we already fetched for. Without this, every time
    // `userInfo` reference changes (which happens on every Redux update
    // that touches the userInfo slice — including the one setUserInfo()
    // *we* dispatch after a successful getMe() resolve) the callback
    // identity changes, and any effect that depends on `getMe` would
    // re-run, hammering /api/users/email/ in a tight loop.
    const lastFetchedEmailRef = useRef<string | undefined>(undefined);

    const getMe = React.useCallback(async () => {
        const email = userInfo?.Email ?? '';
        // Skip the round-trip if we already fetched for this email and
        // still have a userId. Idempotent re-renders (which Redux causes
        // on every dispatch) will short-circuit here instead of firing
        // another /api/users/email/ request.
        if (!email || (lastFetchedEmailRef.current === email && userId)) {
            return;
        }
        try {
            const result = await getUserInfo(email);
            if (result.status === 200) {
                lastFetchedEmailRef.current = email;
                setUserId(result.data?.userId);
                const newUserInfo = {
                    ...userInfo,
                    ...result.data,
                };
                dispatch(setUserInfo(newUserInfo));
            }
        } catch (e) {
            // Handle error
        }
    }, [dispatch, userInfo, userId]);

    return {
        getMe,
        userId,
    };
};
